// TODO Move the file outside the responses folder
export class KeyValue<T1, T2> {

  key: T1;

  value: T2;

}